import layout from '@/pages/layout/index.vue'
import OkrPages from '@/pages/okr/route/index.route'
import PerfPages from '@/pages/performance/route/index.route'
import Statistics from '@/pages/statistics/route/index.route.js'
import { LOGIN_PAGES } from '@/components/login/constants/loginPage'

// 无权限，无路由相关
const NotFound = {
  path: '/:pathMatch(.*)',
  redirect: '/no-auth'
}
// const Page404 = {
//   path: '/404',
//   component: () => import('@/pages/notFound/index.vue')
// }

// 常规登录相关
const loginDefaultPage = [
  {
    path: LOGIN_PAGES.DEFAULT,
    component: () => import('@/pages/login/index.vue'),
    meta: {
      isNoAuth: true,
      loginPage: LOGIN_PAGES.DEFAULT
    }
  },
  {
    path: '/getWechatLoginCode',
    component: () => import('@/components/login/src/wechatWebLogin/getWechatLoginCode.vue'),
    meta: {
      isNoAuth: true
    }
  },
  {
    path: '/login_success',
    component: () => import('@/pages/login/result/success.vue'),
  },
]

// 绑定相关，如绑定飞书
const bindLoginPages = [
  {
    path: LOGIN_PAGES.BIND_LOGIN,
    component: () => import('@/pages/login_bind/components/login/index.vue'),
    meta: {
      isNoAuth: true,
      loginPage: LOGIN_PAGES.BIND_LOGIN
    }
  },
  {
    path: '/login/bind_login/:bindType',
    component: () => import('@/pages/login_bind/bind.vue'),
    meta: {
      isNoAuth: true,
      loginPage: LOGIN_PAGES.BIND_LOGIN
    }
  }
]

// 激活账号页面
const loginActivationPage = [{
  path: '/login/activateAccount/:activateType',
  component: () => import('@/pages/login_activate/index.vue'),
  meta: {
    isNoAuth: true,
    loginPage: LOGIN_PAGES.DEFAULT
  }
}]




// 常规页面
const normalPages = [
  // OKR插件 iframe中提示打开新页面登录
  {
    path: '/iframe/copyokr',
    component: () => import('@/pages/copyOkr/index.vue'),
    meta: {
      isNoAuth: false,
      loginPage: LOGIN_PAGES.DEFAULT
    }
  },
  {
    path: '/index',
    redirect: '/index/okr',
    meta: {
      isNoAuth: true
    },
    children: [
      {
        path: 'okr',
        component: () => import('@/pages/leaflets/okr/index.vue'),
      },
      {
        path: 'perf',
        component: () => import('@/pages/leaflets/perf/index.vue'),
      }
    ]
  },
  {
    path: '/',
    component: layout,
    redirect: 'okr',
    children: [
      {
        path: 'no-auth',
        component: () => import('@/pages/noAuth/index.vue')
      },
      ...OkrPages,
      ...PerfPages
    ]
  }
]

const routes = [
  ...loginDefaultPage,
  ...bindLoginPages,
  ...loginActivationPage,
  ...normalPages,
  ...Statistics,
  NotFound
]
export default routes
